// extracted by mini-css-extract-plugin
export default {"menuBlock":"bJ-z","title":"cJ-z","nav":"dJ-z","flexCell":"eJ-z","facetLink":"fJ-z"};